import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Mirrors the custom keys in @firmable/tailwind-config. Without them tailwind-merge does not see
// `p-sm` or `rounded-radius-md` as padding or radius, keeps the stock shadcn class alongside, and
// the override silently loses.
const twMerge = extendTailwindMerge({
  theme: {
    spacing: ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'],
    borderRadius: ['radius-none', 'radius-sm', 'radius-md', 'radius-lg', 'radius-full'],
  },
  classGroups: {
    // tailwind-merge 1.8 does not file these under their groups, so a site's z-50 would sit beside our z-auto
    // and lose on stylesheet order.
    z: [{ z: ['auto'] }],
    'max-h': [{ 'max-h': ['none'] }],
    'font-size': [
      {
        text: [
          'feature',
          'display',
          'heading',
          'title',
          'caption',
          'body-large',
          'body-small',
          'label-large',
          'label-small',
          'display-xl',
          'display-xxl',
          'display-md',
          'display-sm',
          'l',
          'h1',
          'h2',
          'h3',
          'h4',
          'h5',
        ],
      },
    ],
    shadow: [
      {
        shadow: [
          'btn-bevel',
          'rowHighlight',
          'raised',
          'overlay',
          'overflow',
          'dropdown',
          'rightSidePanel',
          'rowHover',
          'btnFilledShadow',
          'bottom-sheet',
          'elavation2dp',
        ],
      },
    ],
    // shadcn's enter/exit plus our named animations, so a Firmable animate-* class replaces shadcn's
    // animate-in/out instead of both landing on the element (whichever CSS rule comes last would win).
    animate: [
      {
        animate: [
          'in',
          'out',
          'hide',
          'slideIn',
          'swipeOut',
          'overlayShow',
          'contentShow',
          'contentHide',
          'popoverIn',
          'popoverOut',
          'accordion-down',
          'accordion-up',
          'fadeIn',
          'tabIn',
          'tabBarIn',
          'toastSlideDown',
          'toastSlideUp',
          'sheetSlideUp',
          'backdropFadeIn',
          'popIn',
        ],
      },
    ],
  },
});

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
